export default __webpack_public_path__ + "static/media/Squad.d78c1804.ttf";